import * as React from 'react';
import NavigationListJoinGroupAction from './NavigationListJoinGroupAction';
import NavigationListCreateGroupAction from './NavigationListCreateGroupAction';

type Props = {
  actions: { key: string }[];
};

class NavigationListSectionActions extends React.Component<Props> {
  renderAction = ({ key }: { key: string }) => {
    switch (key) {
      case 'create_a_class':
        return <NavigationListCreateGroupAction key={key} />;
      case 'join_a_class':
        return <NavigationListJoinGroupAction key={key} />;
      default:
        console.error(`NavigationListSectionAction - unsupported action ${key}`);
        return null;
    }
  };

  render() {
    const { actions } = this.props;

    if (actions.length === 0) {
      return null;
    }

    return <div>{actions.map(this.renderAction)}</div>;
  }
}

export default NavigationListSectionActions;
